
<template>
  <div class="wrapper">
    <div
      v-if="getRequest && getRequest.length > 0"
      class="join-request-tile"
    >
      <div class="title-container">
        <span class="title">{{ $t('community.ownerRequestTile.pendingApprovalRequests') }}</span>
      </div>
      <div class="description-container">
        <span class="description">{{ $t('community.ownerRequestTile.acceptConfirmation') }}</span>
      </div>
      <div class="valid-join-container">
        <div
          v-for="ownerRequest in getRequest"
          :key="ownerRequest.id"
        >
          <valid-owner-request :owner-request="ownerRequest" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidOwnerRequest from '@/components/community/ValidOwnerRequest'
import { mapState } from 'vuex'

export default {
  name: 'OwnerRequestTile',
  components: { ValidOwnerRequest },
  props: {
    communityDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      ownerRequestForUser: state => state.ownerRequest.ownerRequestForUser
    }),
    getRequest () {
      return this.ownerRequestForUser.filter(request => request.idCommunity === this.communityDetail.idCommunity)
    }
  }
}
</script>

<style scoped lang="scss">

.wrapper {
  width: 100%;
}
  .join-request-tile {
    margin-top: 1rem;
    width: 100%;
    height: fit-content;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
    border-top: solid 2px $cerise-color;

    .title-container {
        padding: 10px 0;

        .title {
            font-size: 15px;
            font-weight: 600;
        }

    }

    .description-container {
        padding: 0 7px;
        text-align: left;

        .description {
            font-size: 13px;
        }
    }

    .valid-join-container {
        padding: 15px 0 10px 0;
    }
  }
</style>
